/**
 * Created by itaic on 7/29/14.
 * This transport is built to send regular HTTP/HTTPS messages
 * over web socket. It's main purpose is to help our mobile implementations
 * and reduce the number of connections we open and close in the browser.
 * It exposes the default lpAjax transport methods + some additional hooks.
 */
window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
lpTag.taglets.websocket2http = lpTag.taglets.websocket2http || (function websocket2http(window) {

    var version = "0.9.4",
        transportType = "websocket2http",
        logType = { DEBUG: "DEBUG", INFO: "INFO", ERROR: "ERROR", TRACE: "TRACE" },
        socketAPI,
        defaults = {
            timeout: 30000
        },
        callCount = 0,
        errorCount = 0,
        pendingRequests = {},
        cancelIds = {},
        allowedDomains = [],
        badRequest = {  statusCode: 400, responseCode: 400, message: "Malformed/Bad request, unable to service it", name: "BADREQUEST"},
        requestNotAllowed = {  statusCode: 401, responseCode: 401, message: "Batch(elor) WS can't service this request.", name: "FORBIDDEN"},
        noConnection = {  statusCode: 500, responseCode: 500, message: "WebSocket is not connected", name: "NOCONNECTION"},
        lastRequestTime;

    init();

    /************************PUBLIC METHODS **********************************/

    /**
     * Plugs in the transport to lpAjax if it exists
     */
    function init() {
        if (!socketAPI) {
            socketAPI = new lpTag.taglets.LPWebSocketWrapper();
        }

        if (!socketAPI.supported) {
            _info("WebSockets not supported", "init");
        }
    }

    /**
     * Allows setting configuration options
     * @param configuration - object can contain:
     * server - location of the server location
     * autoReconnect: true - if to try and reconnect on socket disconnect
     * timeout: 30000, - this is the default timeout sent to batchelor
     * reconnectTimeout : 2000, - how many seconds before socket reconnect attempts
     * maxReconnectAttempt : 30 - how many times we try to reconnect before giving up the socket
     * created - a callback to be called every time a socket is created
     * closed - a callback to be called every time a socket is closed
     * ping :  {
     *      request : the request to ping the server
     *      response : the expected STRING response from the server
     * }
     * idleBeforePing - the time (in milliseconds) of inactivity before a ping is sent
     * @returns {boolean}
     */
    function configure(configuration) {
        var socketConfiguration;
        if (socketAPI.supported && configuration && typeof configuration === 'object') {
            if (typeof configuration.server === 'string') {//This should happen if we don't have a configured, active web socket only
                socketConfiguration = {
                    server: configuration.server,
                    idleBeforePing: 30000,
                    closed: _handleClosed,
                    created: configuration.created,
                    message: _handleMessage,
                    autoReconnect: typeof configuration.autoReconnect === 'boolean' ? configuration.autoReconnect : true,
                    reconnectTimeout: isNaN(configuration.reconnectTimeout) ? 2000 : configuration.reconnectTimeout,
                    maxReconnectAttempt: isNaN(configuration.maxReconnectAttempt) ? 30 : configuration.maxReconnectAttempt
                };
                if (configuration && !isNaN(configuration.timeout)) {
                    defaults.timeout = configuration.timeout;
                }
                return socketAPI.configure(socketConfiguration);
            } else {
                _error("No server set for WebSocket", "configure");
            }
        } else {
            return false;
        }
    }

    /**
     * Validates the basic properties of the request
     * @param request
     * @returns {boolean}
     */
    function isValidRequest(request) {
        var requestValid = false;
        if (socketAPI.connected()) {
            var requestArray = request && request.constructor !== Array ? [request] : request;
            for (var i = 0; i < requestArray.length; i++) {
                if (_validateSingleRequest(requestArray[i])) {
                    requestValid = true;
                } else {
                    requestValid = false;
                    break;
                }
            }
        }
        return requestValid;
    }

    /**
     * Make a request to the server
     * @param request
     */
    function issueCall(request) {
        if (isValidRequest(request)) {
            _runRequest(request);
        } else if (request && socketAPI.connected()) {//Can't service this request
            _runCallbacks("error", request, requestNotAllowed);
        } else { //No connection
            _runCallbacks("error", request, noConnection);
        }
    }

    /**
     * Cancels a repeating request
     * @param cancelId
     * @returns {boolean}
     */
    function cancelPersistentRequest(cancelId) {
        var foundRequest = false,
            requestsToCancel = [];

        if (cancelId) {

            if (typeof cancelId === "string") {
                requestsToCancel = [cancelId];
            }else if(cancelId && cancelId.constructor === Array){
                requestsToCancel = cancelId;
            }

            for(var i =0; i < requestsToCancel.length; i++) {
                if(cancelIds[requestsToCancel[i]]) {
                    _removeCallback(cancelIds[requestsToCancel[i]]);
                    foundRequest = true;
                }
            }
            _cancelRepeater(requestsToCancel);
        }
        return foundRequest;
    }

    /************************PRIVATE METHODS **********************************/

    /**
     * Method for logging
     * @param msg
     * @param type
     * @param callingMethod
     */
    function _log(msg, type, callingMethod) {
        if (window.lpTag && lpTag.log) {
            if(typeof msg === 'string' && callingMethod){
                msg = callingMethod + ': ' + msg;
            }
            lpTag.log(msg, type, transportType);
        }
    }

    /**
     * Shorthand for error logs
     * @param msg
     * @param methodName
     * @private
     */
    function _error(msg, methodName) {
        _log(msg, logType.ERROR, methodName);
    }

    /**
     * Shorthand for debug logs
     * @param msg
     * @param methodName
     * @private
     */
    function _debug(msg, methodName) {
        _log(msg, logType.DEBUG, methodName);
    }

    /**
     * Shorthand for trace logs
     * @param msg object
     * @param methodName
     * @private
     */
    function _trace(msg, methodName ) {
        _log(msg, logType.TRACE, methodName || "");
    }

    /**
     * Shorthand for info logs
     * @param msg
     * @param methodName
     * @private
     */
    function _info(msg, methodName) {
        _log(msg, logType.INFO, methodName);
    }

    /**
     * Validates a single request
     * @param request
     * @returns {boolean}
     * @private
     */
    function _validateSingleRequest(request) {
        return !!(request && typeof request.url === 'string' &&
            request.url.indexOf('http') === 0 &&
            _isAllowedDomain(request.url) &&
            typeof request.success === 'function');

    }

    /**
     * Runs a single request in
     * @param request
     */
    function _runRequest(request) {
        var finalRequest;

        callCount = callCount + 1;
        try {
            finalRequest = _prepareRequests(request);
            socketAPI.send(finalRequest);
            lastRequestTime = new Date().getTime();
        } catch (exc) {
            if (finalRequest) {
                _runErrors(finalRequest);
            }
            _error("Failed to run request, exc " + exc.message, "_runRequest");
            errorCount = errorCount + 1;
        }
    }

    /**
     * Cancels a repeating request on the Batch(elor)
     * @param cancelId
     * @private
     */
    function _cancelRepeater(cancelId) {
        var cancelMessage = {
            "cancelId": cancelId
        };
        if (socketAPI.connected()) {
            socketAPI.send(cancelMessage);
        }
    }

    /**
     * Runs all errors for a request we failed to execute
     * @param requests
     * @private
     */
    function _runErrors(requests) {
        _runCallbacks("error", requests, badRequest);
        for (var i = 0; i < requests.length; i++) {
            _removeCallback(requests[i].name);
        }
    }

    /**
     * Sets up all requests for the response
     * @param request
     * @returns {*}
     * @private
     */
    function _prepareRequests(request) {

        var requestArray = request && request.constructor === Array ? request : ( request ? [request] : []), resultArray = [];
        for (var i = 0; i < requestArray.length; i++) {
            resultArray.push(_prepareSingleRequest(requestArray[i]));
        }
        return resultArray;
    }

    /**
     * Prepares a single request to be sent
     * @param request
     * @returns {*}
     * @private
     */
    function _prepareSingleRequest(request) {
        var id = _generateId(),
            now = new Date().getTime(),
            cleanRequest;

        cleanRequest = _cloneSimpleObj(request);
        cleanRequest = _setUpRequest(cleanRequest);
        cleanRequest.name = id;
        request.launchTime = now;

        pendingRequests[id] = request;

        return cleanRequest;
    }

    /**
     * In case we got configuration we know which domains
     * are now allowed.
     * @param url
     * @returns {boolean}
     */
    function _isAllowedDomain(url) {
        if (allowedDomains.length > 0) {
            var domain,
                validDomain = false,
                splitUrl = /https{0,1}:\/\/([^\/|\s]+)/ig.exec(url);

            domain = splitUrl.length === 2 ? splitUrl[1] : '';
            if (domain) {
                for (var i = 0; i < allowedDomains.length; i++) {
                    validDomain = _verifiedDomain(domain, allowedDomains[i]);
                    if (validDomain) {
                        return validDomain;
                    }
                }
            }
        } else {
            return true;
        }
    }

    /**
     * Verify parent domain in reverse
     * Includes sub domains.
     * Example:
     * AllowedDomains: *.dev.lprnd.net
     * Valid Domains: a.dev.lprnd.net, b.dev.lprnd.net, a.b.dev.lprnd.net, a.b.c.dev.lprnd.net
     * @param domain
     * @param allowedDomain
     * @returns {boolean}
     */
    function _verifiedDomain(domain, allowedDomain) {
        var verified = true;
        var splitDomain1 = domain.split('.');
        if (splitDomain1.length > 2) {
            var splitDomainIndex = splitDomain1.length - 1;
            var allowedDomainSplit = allowedDomain.split('.');
            for (var i = (allowedDomainSplit.length - 1); i >= 0; i--) {
                if (splitDomain1[splitDomainIndex] !== allowedDomainSplit[i] && allowedDomainSplit[i] !== "*") {
                    verified = false;
                    break;
                } else if (splitDomainIndex - 1 > 0) {
                    splitDomainIndex = splitDomainIndex - 1;
                } else {
                    break;
                }
            }
        } else {
            verified = false;
        }
        return verified;
    }

    /**
     * Runs pending callbacks as a result of a message
     * @param message
     * @private
     */
    function _handleMessage(message) {
        if(typeof message === 'object') {
            for (var key in message) {
                if (message.hasOwnProperty(key) && key) {
                    if (pendingRequests[key]) {
                        _runMessageResponse(key, pendingRequests[key], message[key]);
                    }
                    else if (key === 'config' && message[key].allowDomain) {
                        _setAllowedDomains(message[key].allowDomain);
                    }
                    else {
                        _error("Callback not found for key:" + key + " response:" + JSON.stringify(message[key]), "_handleMessage");
                    }
                }
            }
        }else{
            _error("Message response not an object: " + message, "_handleMessage");
        }
    }

    /**
     * Handles when the socket closes
     * @param data
     * @private
     */
    function _handleClosed(data) {
        _runCallbacks("error", pendingRequests, noConnection);
        _error("Socket closed: " + JSON.stringify(data));
    }

    /**
     * In order to match our convention for all APIs
     * @param response
     * @returns {*}
     * @private
     */
    function _addResponseCode(response) {
        if (typeof response.responseCode === 'undefined'){
            if(typeof response.statusCode !== 'undefined'){
                response.responseCode = response.statusCode;
            }else if(typeof response.HTTPStatus !== 'undefined'){
                response.responseCode = response.HTTPStatus;
            }
        }
        return response;
    }

    /**
     * Runs a res
     * @param key
     * @param queuedRequest
     * @param response
     * @private
     */
    function _runMessageResponse(key, queuedRequest, response){
        var queuedCallback;
        if (response) {
            response = _addResponseCode(response);

            if (response.responseCode < 400 || (response.statusCode && response.statusCode < 400)) {
                queuedCallback = queuedRequest.success;
            } else {
                queuedCallback = queuedRequest.error;
                errorCount = errorCount + 1;
            }
            if (_isPersistent(key)) {
                if (typeof response === 'object') {
                    response.requestName = key;
                }
                _saveCancelId(key, response.cancelId);
            } else {
                _removeCallback(key);
            }
            _trace(_createTrace(queuedRequest, response), "_runMessageResponse");
            _runCallback(queuedCallback, response, queuedRequest.context);
            _debug("Ran response for key: " + key, "_runMessageResponse");
        }
    }

    function _createTrace(request, response) {
        var res = {},
            now = new Date().getTime();
        res[request.url] = {
            duration: (now - request.launchTime),
            request: _cloneSimpleObj(request),
            response: _cloneSimpleObj(response)
        };

        return res;
    }

    /**
     * Stores the cancelId for the persistent request
     * @param key
     * @param cancelId
     * @private
     */
    function _saveCancelId(requestId, cancelId) {
        if (cancelId && pendingRequests[requestId]) {
            pendingRequests[requestId].cancelId = cancelId;
            cancelIds[cancelId] = requestId;//Reverse mapping for removal
        }
    }

    /**
     * Checks if this request is persistent
     * @param key
     * @returns {*|boolean}
     */
    function _isPersistent(key){
        return (pendingRequests[key] && pendingRequests[key].persistent === true);
    }

    /**
     * Sets the allowed domains for the scope based on the socket message
     * @param allowed
     * @private
     */
    function _setAllowedDomains(allowed) {
        allowedDomains = allowed;
        if (allowedDomains && allowedDomains.constructor === Array &&
            allowedDomains.length === 1 && allowedDomains[0] === "*") {
            allowedDomains.length = 0;
        }
        _debug("Allowed Domains: " + JSON.stringify(allowed), "_setAllowedDomains");
    }

    /**
     * Removes a callback from the queue
     * @param key
     * @private
     */
    function _removeCallback(key) {
        pendingRequests[key] = null;
        delete pendingRequests[key];
    }

    /**
     * Wraoped method for executing call backs
     * @param cb
     * @param data
     * @param context
     * @private
     */
    function _runCallback(cb, data, context) {
        if (typeof cb === 'function') {
            try {
                cb.call(context || null, data);
            } catch (exc) {
                _error("Error executing callback", "_runCallback");
            }
        }
    }

    /**
     * Masks running a single response as opposed
     * to an array of responses
     * @param type
     * @param request
     * @param data
     * @private
     */
    function _runCallbacks(type, request, data) {
        var requestsArray;
        if (request) {
            requestsArray = request.constructor === Array ? request : [request];
            for (var i = 0; i < requestsArray.length; i++) {
                _runCallback(requestsArray[i][type], _cloneSimpleObj(data), requestsArray[i].context);
            }
        }
        requestsArray = null;
    }

    /**
     * Creates a unique id so we can understand the response
     * @returns {string}
     * @private
     */
    function _generateId() {
        return "ws" + (Math.abs(Math.round(Math.random() * 9999999999)) + new Date().getTime());
    }

    /**
     * Takes the data parameter and converts it to a query string
     * @param data
     * @return {String}
     */
    function _convertDataToQueryParams(data) {
        var queryString = "";
        if (typeof data === 'string') {
            queryString += data;
        } else {
            var first = true;
            for (var key in data) {
                var value;
                if (typeof data[key] == 'object') {
                    value = JSON.stringify(data[key]);
                } else if (typeof data[key] !== 'function') {
                    value = data[key];
                }
                if (typeof value !== 'undefined') {
                    if (!first) {
                        queryString += "&";
                    }
                    queryString += encodeURIComponent(key) + "=" + encodeURIComponent(value);
                    first = false;
                }
            }
        }
        return queryString;
    }

    /**
     * Build URL query as GET
     * @param url
     * @param data
     * @returns {*}
     */
    function _setUrlQuery(url, data){
        var dataString =  _convertDataToQueryParams(data);
        if (dataString) {
            url += url.indexOf("?") < 0 ? "?" : "&";
            url += dataString;
        }
        return url;
    }

    /**
     * Setting up defaults for all requests
     * @param request
     * @returns {*}
     * @private
     */
    function _setUpRequest(request) {
        if (!request.method) {
            request.method = 'GET';
        }
        if (isNaN(request.timeout)) {
            request.timeout = defaults.timeout;
        }

        request.caseSensitiveHeaders = request.caseSensitiveHeaders === false ? false : true;

        // TODO: SHOULD BE MOVED TO lpBatchelor or Bachelor
        // Set the queryparams on the url
        if (request.query) {
            request.url =  _setUrlQuery(request.url, request.query);
            request.query = null;
        }

        return request;
    }

    /**
     * Flat clone method, only clones data ignoring functions
     * @param obj
     * @return {Object}
     */
    function _cloneSimpleObj(obj) {
      try{
          return JSON.parse(_stringify(obj));
      }catch (exc){
          _error("Failed to clone object", "_cloneSimpleObj");
          return new Error("Failed to clone object");
      }
    }

    /**
     * This function was added because of incompatibility between the JSON._stringify and Prototype.js library
     * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
     * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
     * The function accepts a value and and uses the native JSON._stringify
     * Can throw an exception (same as JSON._stringify).
     */
    function _stringify(value) {
        var stringified;
        if (typeof Array.prototype.toJSON === 'function') {
            var toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    /************************RETURNED OBJECT **********************************/
    var publicAPI = {
        init: init,
        configure: configure,
        name: transportType,
        version: version,
        issueCall: issueCall,
        cancelPersistentRequest: cancelPersistentRequest,
        isValidRequest: isValidRequest,
        inspect: function () {
            return {
                name: transportType,
                version: version,
                callsMade: callCount,
                errorsFound: errorCount
            };
        }
    };

    if (socketAPI && socketAPI.supported && lpTag.taglets.lpAjax) {
        try {
            lpTag.taglets.lpAjax.addTransport(transportType, publicAPI);
        } catch (exc) {}
    }
    return publicAPI;
})(window);